var collectionFilters = document.querySelector("[data-collection-filters]");
var collectionFiltersSidemenu = document.querySelector("[data-collection-filters-sidemenu]");
var collectionFiltersList = document.querySelector("[data-collection-filters-active]");
var collectionFiltersNumbers = document.querySelectorAll("[data-filters-number]");
var collectionFilterTotalProduct = document.querySelector("[data-filters-total-product]");
var filterLink = document.querySelector("[data-filter-link]");

// OPEN SIDEMENU
var collectionFiltersOpen = document.querySelectorAll("[data-collection-filters-open]");
openFilters();

// CLOSE SIDEMENU
var collectionFiltersCloses = document.querySelectorAll("[data-collection-filters-close]");
closeFilters();

// UPDATE ACTIVE TAGS FILTERS
var activeFilters = [];
var categories = document.querySelectorAll("[data-filter-category]");
var collectionCards = document.querySelectorAll("[data-product-filters]");
var collectionFilterType = document.querySelectorAll("[data-filter-type]");
var collectionFilterValue = document.querySelectorAll("[data-filter-value]");

function applySelectedClass(sortBy) {
    const sortOptions = document.querySelectorAll("#customSortOptions .sort_filter");
    let isSortApplied = false;

    sortOptions.forEach((option, index) => {
        const sortType = option.getAttribute('data-sort');
        const isMatch = sortType === sortBy || (!sortBy && index === 0);
        option.classList.toggle("selected", isMatch);
        if (isMatch) isSortApplied = true;
    });

    if (!isSortApplied && sortOptions.length > 0) {
        sortOptions[0].classList.add("selected");
    }
}

function redirectToSortUrl(sortType) {
    const sortByUrlMap = {
        "best-selling": "best-selling",
        "price-ascending": "price-ascending",
        "price-descending": "price-descending",
        "": "manual" // Par défaut
    };
    const newUrl = `${window.location.pathname}?sort_by=${sortByUrlMap[sortType] || "manual"}`;
    window.location.href = newUrl;
}

function setupSortOptions() {
    const sortOptions = document.querySelectorAll("#customSortOptions .sort_filter");
    sortOptions.forEach(option => {
        option.addEventListener('click', () => {
            const sortType = option.getAttribute('data-sort');
            redirectToSortUrl(sortType);
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const setupStickyFilters = (headerSelector, filtersSelector ) => {
        const header = document.querySelector(headerSelector);
        const filters = document.querySelector(filtersSelector);

        if (!header || !filters) {
            return;
        }

        // Détermine l'offset initial
        const initialFiltersOffsetTop = filters.getBoundingClientRect().top + window.scrollY ;

        // Ajuste la position des filtres
        const adjustFiltersPosition = () => {
            const headerBottom = header.getBoundingClientRect().bottom;
            const filtersTop = filters.getBoundingClientRect().top;
            const scrollY = window.scrollY;

            if (headerBottom >= filtersTop && scrollY >= initialFiltersOffsetTop - header.offsetHeight) {
                filters.style.position = "fixed";
                filters.style.top = `${header.offsetHeight}px`;
                filters.style.zIndex = "1000";
            } else if (scrollY < initialFiltersOffsetTop) {
                filters.style.position = "relative";
                filters.style.top = "auto";
            }
        };

        // Ajoute l'écoute de scroll
        window.addEventListener("scroll", adjustFiltersPosition);
    };

    // Initialisation pour mobile
    setTimeout(() => {
        setupStickyFilters(".header--mobile__container", ".filters-mobile");
    }, 200);

    // Initialisation pour desktop
    setupStickyFilters(".header--desktop", ".collection__filters-nav-bar");
});

document.addEventListener("DOMContentLoaded", () => {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get("sort_by") || "";
    applySelectedClass(sortBy);
    setupSortOptions();
});


collectionFilterValue.forEach((value) => {
    value.addEventListener('click', () => {
        if (filterLink != undefined) filterLink.classList.add("hide");
        // Add / Remove class active of the filter value clicked
        updateFilterActiveClass(value);
        // Update active filters array
        updateActiveFilters();
        // Add / Remove class hide for each card
        updateCardsClass();
    })
})
collectionFilterType.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
        // Update active filters array
        updateActiveFilters();
        // Add / Remove class hide for each card
        updateCardsClass();
    })
});

function addEventListenerFilterTags() {
    var filterTags = document.querySelectorAll("[data-filter-tag]");
    filterTags.forEach(tag => {
        tag.addEventListener("click", () => {
            var data = tag.dataset.filterTag;
            document.querySelector("[data-filter-value='" + data + "']").click();
        });
    })
}


function openFilters() {
    if (collectionFiltersOpen == undefined) return false;
    collectionFiltersOpen.forEach((filter) => {
        filter.addEventListener('click', () => {
            if (collectionFilters == undefined || collectionFiltersSidemenu == undefined) return false;
            collectionFilters.classList.add("active");
            setTimeout(() => {
                collectionFiltersSidemenu.classList.add("active");
            }, 100);
        })
    })
}

function closeFilters() {
    if (collectionFiltersCloses.length < 1) return false;

    collectionFiltersCloses.forEach(collectionFiltersClose => {
        collectionFiltersClose.addEventListener('click', () => {
            if (collectionFilters == undefined || collectionFiltersSidemenu == undefined) return false;
            collectionFiltersSidemenu.classList.remove("active");
            setTimeout(() => {
                collectionFilters.classList.remove("active");
            }, 500);
        })
    })
}

function updateFilterActiveClass(value) {
    // UPDATE ACTIVE CLASS FOR A VALUE
    if (value.classList.contains("active"))
        value.classList.remove("active");
    else
        value.classList.add("active");

    // BON PARFUMEUR
    if (document.querySelector(".all-collection__blocks") != undefined
        && !document.querySelector(".all-collection__blocks").classList.contains("hide")) {
        document.querySelector(".collection").classList.remove("hide");
        document.querySelector(".all-collection__blocks").classList.add("hide");
    }
}

function updateActiveFilters() {
    // EMPTY OLD ACTIVE FILTERS
    activeFilters = [];

    categories.forEach((category) => {
        var categoryTitle = category.dataset.filterCategory;
        var categoryType = category.querySelector("[data-filter-type]").checked;
        var categoryValues = [];
        var categoryValString = [];

        category.querySelectorAll("[data-filter-value]").forEach((filter) => {
            if (filter.classList.contains("active")) {
                categoryValues.push(filter.dataset.filterValue);
                var valString = filter.querySelector("span");
                categoryValString.push(valString.innerHTML);
            }
        });

        activeFilters.push({
            "handle": categoryTitle,
            "adds_up": categoryType,
            "values": categoryValues,
            "valString": categoryValString
        });

    });

    updateActiveFiltersList();
    updateFiltersnumber();
}

// ALGO
function updateCardsClass() {
    collectionCards.forEach((card) => { // Pour chaque carte
        var cardFilters = card.dataset.productFilters;
        if (cardFilters != undefined) { // Si la carte contient des tags
            var cardFiltersArray = cardFilters.split(",");
            cardFiltersArray = cardFiltersArray.filter(function (n) {
                return n;
            });

            var cardHide = false;
            activeFilters.forEach((category) => { // Pour chaque categorie
                if (category.values.length > 0) {
                    // Comparaison des occurences des tableaux des catégories avec le tableau des tags d'une carte
                    var occurences = category.values.filter(v => cardFiltersArray.includes(v));
                    if ((occurences.length != category.values.length && !category.adds_up) || occurences.length < 1) {
                        cardHide = true;
                    }
                }
            });

            if (cardHide) card.classList.add("hide");
            else card.classList.remove("hide");
        }
    })
    getTotalProductsAvailable();
}

function updateActiveFiltersList() {
    collectionFiltersList.innerHTML = "";
    activeFilters.forEach(filter => {
        createNewFilterTags(filter);
    });
    addEventListenerFilterTags();
}

function updateFiltersnumber() {
    var nbr = 0;
    activeFilters.forEach(filter => {
        nbr = nbr + filter.values.length;
    });

    collectionFiltersNumbers.forEach(collectionFiltersNumber => {
        collectionFiltersNumber.innerHTML = nbr;
    })
}

function createNewFilterTags(filter) {
    filter.valString.forEach((val, index) => {
        var div = document.createElement("div");
        var p = document.createElement("p");

        var title = val.replace("amp;", "");
        var handle = filter.values[index];

        div.classList.add("collection__filter-tag-container");
        div.setAttribute('data-filter-tag', handle);

        p.classList.add("collection__filter-tag");
        p.textContent = title;
        div.appendChild(p);

        collectionFiltersList.appendChild(div);
    })
}

var collectionFilterClear = document.querySelector("[data-filter-clear]");
collectionFilterClear.addEventListener("click", () => {
    removeAllFilters();
    if (filterLink != undefined) filterLink.classList.remove("hide");
})

function getTotalProductsAvailable() {
    var totalDiv = document.querySelectorAll("[data-product-filters]").length;
    var totalDivHide = document.querySelectorAll("[data-product-filters].hide").length;
    var total = totalDiv - totalDivHide;
    collectionFilterTotalProduct.innerHTML = total;
}

function removeAllFilters() {
    collectionFiltersList.innerHTML = "";
    collectionCards.forEach(card => {
        card.classList.remove("hide");
    });
    collectionFilterValue.forEach(value => {
        value.classList.remove("active");
    })

    // BON PARFUMEUR
    if (document.querySelector(".all-collection__blocks") != undefined) {
        document.querySelector(".collection").classList.add("hide");
        document.querySelector(".all-collection__blocks").classList.remove("hide");
    }
}

